import { render, staticRenderFns } from "./1800_Social_Media_Infographic.vue?vue&type=template&id=667d0bef&scoped=true&lang=pug"
var script = {}
import style0 from "./1800_Social_Media_Infographic.vue?vue&type=style&index=0&id=667d0bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d0bef",
  null
  
)

export default component.exports